<div class="grid min-h-20 grid-cols-3 gap-3 lg:grid-cols-6">
  @for (channel of channels; track channel.id) {
    <pxc-cross-badge [isActive]="removable" (remove)="removeChannel.emit(channel)">
      <pxc-channel-preview size="small" [channel]="channel" [showDetails]="false" [vertical]="true" />
    </pxc-cross-badge>
  }
  @for (user of users; track user.id) {
    <pxc-cross-badge [isActive]="removable" (remove)="removeUser.emit(user)">
      <pxc-user-card size="small" [showSpecialty]="false" [user]="user" [vertical]="true" />
    </pxc-cross-badge>
  }
  @for (mailAddress of mailAddresses; track mailAddress) {
    <pxc-cross-badge [isActive]="removable" (remove)="removeMailAddress.emit(mailAddress)">
      <pxc-user-card showSpecialty="false" size="small" [mailAddress]="mailAddress" [vertical]="true" />
    </pxc-cross-badge>
  }
</div>
